// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-e85aecc2]{left:0;overflow:hidden;position:absolute;top:-17vw;width:100vw;z-index:-1}@media screen and (min-width:320px) and (max-width:998px) and (orientation:landscape){div[data-v-e85aecc2]{top:-24vw}}#sun[data-v-e85aecc2]{left:40%;position:relative;right:0;top:-1.25em;width:60%;z-index:-1}#hills[data-v-e85aecc2]{position:absolute;top:25vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
